module.exports = __webpack_public_path__ + "media/images/gallery/eclipse_off-9c0eacbe08a7d0b929e8aa7049531c79.gif";